import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function WikiSearchBar({ initialValue = "", className = "", compact = false }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState(initialValue);

  const submit = (e) => {
    e?.preventDefault?.();
    const clean = query.trim();
    if (!clean) return;
    navigate(`/wiki/search?q=${encodeURIComponent(clean)}`);
  };

  return (
    <form data-testid="wiki-search-form" onSubmit={submit} className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <Input
        data-testid="wiki-search-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search the archives"
        className={compact ? "bg-zinc-950/70 border-amber-900/30 text-zinc-100" : "h-11 bg-zinc-950/70 border-amber-900/30 text-zinc-100"}
      />
      <Button data-testid="wiki-search-submit" type="submit" variant="outline" className="border-amber-700/40 bg-amber-950/20 text-amber-200 hover:bg-amber-900/30">
        Search
      </Button>
    </form>
  );
}